import React, { ReactElement } from "react";
import scrmLogo from "../../public/images/svg/scrmLogo.svg";
import UserProfileMenu from "../components/UserProfileMenu/UserProfileMenu";

export default function Header(): ReactElement {
  const render = () => (
    <header
      className={`top-0 fixed w-screen z-10 bg-gray-150 overflow-hidden flex-none h-14 text-sm 2xl:h-[84px] border-b-2 border-gray-300 text-blue-600 `}
    >
      <div
        id="header-content"
        className="flex flow-row items-center h-full justify-between"
      >
        <div id="branding-area" className="pl-4 flex-1">
          <a href="/" className="flex flex-row">
            <img src={scrmLogo} className="h-8 mx-2" alt="Logo" />
          </a>
        </div>
        <div
          id="header-links"
          className="h-full flex flex-auto items-center justify-center"
        ></div>
        <UserProfileMenu />
      </div>
    </header>
  );

  return render();
}
